import React, {Component, Fragment} from 'react'
import {DropzoneArea} from 'material-ui-dropzone'
import { storage } from '../../../../../config/firebaseConfig'
import { Paper, Button } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import {connect } from 'react-redux'
import {logoUpdate} from '../../../../../store/Actions/memberActions/memberActions'

const style = {

  logo : {
    width: '200px',
    margin:' 0 auto',
    display: 'block'
  },
  paper : {
    width: '200px',
    margin:' 0 auto',
    display: 'block',
    position: 'relative'
  },
  deleteButton: {
    position: 'absolute',
    top: 0,
    right: 0,
    opacity:  0,
    transition: 'all .33s'
  }
  
}

class LogoUpload extends Component{
  constructor(props){
    super(props);
    this.state = {
      companyLogoUrl: '',
      companyLogoName: '',
      companyId: ''
    };
    this.handleDeleteLogo = this.handleDeleteLogo.bind(this);
  }
  handleChange(files){
    
    // this.setState({
    //   file: files
    // });
    

    const image = files[0]
    //console.log(image.name)
    if(image){
      // this.setState({
      //   ...this.state,
      //   companyLogoName: image.name
      // })
   
        const uploadTask = storage.ref('images/'+ this.state.companyId +'/'+ image.name ).put(image)

        uploadTask.on('state_changed', 
        
            (snapshot) => {
              var percent = snapshot.bytesTransferred / snapshot.totalBytes * 100;
              console.log(percent + "% done");
            },
            (error) => {
              console.log(error)
            },
            () => {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                uploadTask.snapshot.ref.getDownloadURL()
                .then(downloadURL => {
                    //console.log('File available at', downloadURL)
                    this.setState({
                      ...this.state,
                      companyLogoUrl: downloadURL,
                      companyLogoName: image.name
                    })
                    sessionStorage.setItem('companyLogoUrl', downloadURL)
                    sessionStorage.setItem('companyLogoName', image.name)
                    this.props.logoUpdate(this.state)
                    this.props.handleLogoChange()
                  }
                )
            }
        )
    }
  }

  handleDelete(e){
    //let uid = this.state.user.uid
     let img = e.name
     storage.ref('images').child(this.state.companyId).child(img).delete()
     //db.ref('users').child(this.props.auth.uid).child('logo').remove()
     this.props.handleLogoChange()
  }
  changeLogoState = () => {
    this.setState({
      ...this.state,
       companyLogoUrl:  '',
       companyLogoName:  '',
      
    })
  }
  handleDeleteLogo = async () => {
    let img = this.state.companyLogoName
    storage.ref('images').child(this.state.companyId).child(img).delete()
    .then(()=>{
      this.changeLogoState()
    })
    .then( () => {
      let deleteLogo = this.state.companyLogoName 
      if(deleteLogo === '' ){
         this.props.logoUpdate(this.state)
         sessionStorage.removeItem('companyLogoUrl')
         sessionStorage.removeItem('companyLogoName')
      }
    })  
  }
  componentDidMount(){
      this.setState({
        ...this.state,
        companyLogoUrl: sessionStorage.getItem('companyLogoUrl')|| '',
        companyLogoName: sessionStorage.getItem('companyLogoName') || '',
        companyId: sessionStorage.getItem('companyId') || ''
      })
    
  }
  render(){
    return (
      <Fragment>
         { this.state.companyLogoUrl === '' ?
            <DropzoneArea
                
                  acceptedFiles={['image/jpeg', 'image/png']}
                  //showPreviews={true}
                  maxFileSize={50000}
                  filesLimit={1}
                  showPreviewsInDropzone= {true}
                  dropZoneClass='dropzone'
                  onChange={this.handleChange.bind(this)}
                  onDelete={this.handleDelete}
             />
             :
             <Paper className='logoPaper' style={style.paper}>
               <img style={style.logo} src={this.state.companyLogoUrl} alt={this.state.companyLogoName}></img>
               <Button onClick={this.handleDeleteLogo}  className="logoButton"  style={style.deleteButton}><DeleteIcon/> </Button>
             </Paper>
         }
      </Fragment>
    )  
  }
} 
const mapStateToProps = (state)=> {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile  
  };
};
export default  connect(mapStateToProps,{logoUpdate})(LogoUpload)